export default __webpack_public_path__ + "static/media/water-consumed-icon.ed309ff8.svg";